<template>
  <a-card title="社区评论" >
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
          <a-input placeholder="Comment ID" v-model:value="formSearch.id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="Article ID" v-model:value="formSearch.article_id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="用户 ID" v-model:value="formSearch.user_id" />
        </a-form-item>
        <!-- <a-form-item>
          <a-input placeholder="标题" v-model:value="formSearch.title" />
        </a-form-item> -->
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
         <template #ori_img_url="{ record }">
          <a-image
              v-if="record.ori_img_url"
              style="width: 150px"
              placehoder=false
              :preview='{src: rawImage(record.ori_img_url)}'
              :src="thumbnail(record.ori_img_url)"
            />
        </template>
        <template #img_url="{ record }">
          <a-tag  v-if="record.status == 1" color="red">任务执行中</a-tag>
          <a-tag  v-if="record.status == 3" color="red">任务失败</a-tag>
          <a-image
              v-if="record.img_url"
              style="width: 150px"
              placehoder=false
              :preview='{src: rawImage(record.img_url)}'
              :src="thumbnail(record.img_url)"
            />
        </template>
         <template #prompt="{ record }">
          <div >
              <div>{{ record.content }}</div>
              <hr />
              <div>Prompt: {{ record.prompt }}</div>
            </div>
          
        </template>
        <template #is_delete="{ record }">
          <a-tag v-if="record.is_delete == 1" color="red">已删除</a-tag>
          <a-tag v-else color="green">正常</a-tag>
        </template>
        <template #created_at="{ record }">
          <div>创建时间: {{ record.created_at.toLocaleString() }}</div>
          <div>修改时间: {{ record.updated_at.toLocaleString() }}</div>
        </template>
        <template #action="{ record }">
          <a-space>
            <a-popconfirm
              title="确定删除吗?"
              ok-text="确定"
              cancel-text="不了"
              @confirm="handleDelete(record)"
            >
              <a-button v-if="record.is_delete == 0"   danger   >删除</a-button>
            </a-popconfirm>
          </a-space>
        </template>
         <template #expandedRowRender="{record}">
        <div>
          <div v-for="(value, key) of record" :key="key">
            <a-row v-if="value != ''">
              <a-col :span="2" >{{ key }}:</a-col>
              <a-col :span="10" >{{ value }}</a-col>
            </a-row>
          </div>
        </div>
      </template>
      </a-table>
  </a-card>

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { thumbnail, rawImage } from '@/utils/image'

export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
       formSearch: {
        user_id: '',
        title: '',
        id: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.formSearch.article_id = this.$route.query.article_id
    this.handleTableChange()
  },
  computed:{},
  methods: {
    thumbnail,
    rawImage,
    handleDelete: function(record) {
      this.loading = true
      request.delete('/api/community/comments/' + record.id).then((rsp) => {
        this.handleTableChange()
        // this.noticeMessage = '删除成功'
      }).catch((err) => {
        // this.noticeMessage = '删除失败'
      }).finally(() => {
        this.loading = false
      })
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      if (!pagi) {
        pagi = this.pagination
      }
      this.loading = true
      const rsp = await request.get('/api/community/comments', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch
      })
      for (let item of rsp.data.list) {
        item.created_at = new Date(item.created_at)
        item.updated_at = new Date(item.updated_at)
      }
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
        {
          title: '主贴 ID',
          dataIndex: 'article_id',
          key: 'article_id',
        },
        {
          title: '评论 ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '用户 ID',
          key: 'user_id',
          dataIndex: 'user_id',
        },
        {
          title: '用户昵称',
          key: 'nickname',
          dataIndex: 'nickname',
        },
         {
          title: '原图',
          key: 'ori_img_url',
          dataIndex: 'ori_img_url',
          slots: { customRender: 'ori_img_url' },
        },
         {
          title: '结果图',
          key: 'img_url',
          dataIndex: 'img_url',
          slots: { customRender: 'img_url' },
        },
         {
          title: 'prompt',
          key: 'prompt',
          dataIndex: 'prompt',
          slots: { customRender: 'prompt' },
        },
         {
          title: 'like_count',
          key: 'like_count',
          dataIndex: 'like_count',
        },
         {
          title: 'is_delete',
          key: 'is_delete',
          dataIndex: 'is_delete',
          slots: { customRender: 'is_delete' },
        },
       
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
          slots: { customRender: 'created_at' },

        },
       
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },

        },
        
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>